export default "__VITE_ASSET__DSMz_yQu__"